import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export const OSLO_TIME_ZONE = "Europe/Oslo";

const OSLO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function isValidOsloDateString(value) {
  if (typeof value !== "string" || !OSLO_DATE_REGEX.test(value)) {
    return false;
  }

  const [year, month, day] = value.split("-").map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  return (
    utcDate.getUTCFullYear() === year &&
    utcDate.getUTCMonth() === month - 1 &&
    utcDate.getUTCDate() === day
  );
}

export function toOsloDateString(dateLike) {
  if (!dateLike) return null;
  if (isValidOsloDateString(dateLike)) return dateLike;

  const parsed = dateLike instanceof Date ? dateLike : new Date(dateLike);
  if (Number.isNaN(parsed.getTime())) return null;

  return formatInTimeZone(parsed, OSLO_TIME_ZONE, "yyyy-MM-dd");
}

export function osloDateToPickerDate(osloDateString) {
  if (!isValidOsloDateString(osloDateString)) return null;
  const [year, month, day] = osloDateString.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function compareOsloDates(a, b) {
  if (!isValidOsloDateString(a) || !isValidOsloDateString(b)) {
    return 0;
  }
  if (a === b) return 0;
  return a < b ? -1 : 1;
}

export function daysInclusiveOslo(startDate, endDate) {
  if (!isValidOsloDateString(startDate) || !isValidOsloDateString(endDate)) {
    return 0;
  }

  const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
  const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

  const startUtc = Date.UTC(startYear, startMonth - 1, startDay);
  const endUtc = Date.UTC(endYear, endMonth - 1, endDay);
  if (endUtc < startUtc) return 0;

  const dayDiff = Math.floor((endUtc - startUtc) / 86400000);
  return dayDiff + 1;
}

export function osloDateTimeToUtcIso(osloDateString, time) {
  if (!isValidOsloDateString(osloDateString) || !time) {
    return null;
  }

  const zonedDate = fromZonedTime(`${osloDateString}T${time}:00`, OSLO_TIME_ZONE);
  if (Number.isNaN(zonedDate.getTime())) return null;
  return zonedDate.toISOString();
}
